import api from 'api';

export const loadCredentials = api(
  'GET /api/lookalikes-audiences/fields/credentials'
);
export const loadDataTypes = api(
  'GET /api/lookalikes-audiences/fields/data-types'
);
export const loadPartnerAudiences = api(
  'GET /api/lookalikes-audiences/fields/partner-audiences'
);
export const loadPartners = api(
  'GET /api/lookalikes-audiences/fields/partners'
);
export const loadTikTokSystems = api(
  'GET /api/lookalikes-audiences/fields/tiktok-systems'
);
export const loadTikTokPlacements = api(
  'GET /api/lookalikes-audiences/fields/tiktok-placements'
);
export const loadTikTokSizes = api(
  'GET /api/lookalikes-audiences/fields/tiktok-sizes'
);
export const loadAccounts = api(
  'GET /api/lookalikes-audiences/fields/accounts'
);
export const loadCampaigns = api(
  'GET /api/lookalikes-audiences/fields/campaigns'
);
export const loadAdSets = api('GET /api/lookalikes-audiences/fields/adsets');
export const loadCountries = api(
  'GET /api/lookalikes-audiences/fields/countries'
);
export const loadGeneratedLookalikes = api(
  'POST /api/lookalikes-audiences/fields/generate'
);
export const loadLookalikes = api(
  'GET /api/lookalikes-audiences/fields/lookalikes'
);
export const loadSnapchatTypes = api(
  'GET /api/lookalikes-audiences/fields/snapchat-types'
);
